import { useQuery } from "@apollo/client";
import { useAuth } from "@the-volte/svc-core-sdk";
import gql from "graphql-tag";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";

import { siteUrl } from "@app/constants";
import { useLocalStorage } from "@hooks/useLocalStorage";

const SEARCH_ROUTE = "/search";

const GET_ORDER_BY_DECLINED_VOUCHER = gql`
  query GetOrderByDeclinedVoucher($declinedOrderVoucherCode: String) {
    order(declinedOrderVoucherCode: $declinedOrderVoucherCode) {
      id
      declinedOrderVoucher {
        id
        code
      }
    }
  }
`;

export const useDeclinedOrderDiscountVoucher = () => {
  const [voucherValid, setVoucherValid] = useState(false);
  const [declinedOrderVoucher, setDeclinedOrderVoucher] =
    useLocalStorage<string>("declinedOrderVoucher", undefined);

  const router = useRouter();
  const { asPath, pathname } = router;
  const { user } = useAuth();
  const declinedVoucherCodeParam = useMemo(() => {
    const url = new URL(`${siteUrl}/${asPath}`);
    return url.searchParams.get("declinedVoucherCode");
  }, []);

  const { loading: orderLoading } = useQuery(GET_ORDER_BY_DECLINED_VOUCHER, {
    variables: {
      declinedOrderVoucherCode: declinedOrderVoucher,
    },
    fetchPolicy: "no-cache",
    skip: !declinedOrderVoucher || !user,
    onCompleted: () => {
      setVoucherValid(true);

      const url = new URL(window.location.href);
      const declinedVoucherCode = url.searchParams.get("declinedVoucherCode");

      if (!declinedVoucherCode) return;

      url.searchParams.delete("declinedVoucherCode");
      router.replace(url.toString(), undefined, { shallow: true });
    },
  });

  useEffect(() => {
    if (declinedVoucherCodeParam && pathname === SEARCH_ROUTE) {
      setDeclinedOrderVoucher(declinedVoucherCodeParam as string);
    }
  }, [declinedVoucherCodeParam, pathname]);

  return {
    declinedOrderVoucher,
    declinedVoucherCodeParam,
    orderLoading,
    voucherValid,
  };
};
